<template>
  <b-table
    :data="recordings"
    default-sort-direction="desc"
    default-sort="date"
    icon-pack="fas"
    per-page="15"
    paginated
    detailed
    detail-key="audioUrl"
    show-detail-icon
  >
    <b-table-column field="date" label="Date" sortable v-slot="props">
      <p class="has-text-grey">
        {{ new Date(props.row.date) | formatDate }}
      </p>
    </b-table-column>
    <b-table-column
      field="lengthInSeconds"
      label="Length"
      sortable
      v-slot="props"
    >
      {{ props.row.lengthInSeconds }}
    </b-table-column>
    <b-table-column
      field="sectionNumber"
      label="Section"
      centered
      sortable
      v-slot="props"
    >
      <router-link
        :to="getSectionPath(props.row.bookId, props.row.sectionNumber)"
      >
        Section {{ props.row.sectionNumber }}
      </router-link>
    </b-table-column>
    <b-table-column
      class="is-size-7"
      field="bookName"
      label="Book"
      sortable
      v-slot="props"
    >
      <p class="is-size-7">{{ props.row.bookName }}</p>
    </b-table-column>
    <template slot="detail" slot-scope="props">
      <IntervalPlayer :src="props.row.audioUrl" :from="0" />
    </template>
  </b-table>
</template>

<script>
import filtersMixin from "@/mixins/filtersMixin";
import routeMixin from "@/mixins/routeMixin";
import IntervalPlayer from "@/components/IntervalPlayer";

export default {
  props: ["recordings"],
  mixins: [filtersMixin, routeMixin],
  components: { IntervalPlayer }
};
</script>

<style lang="scss" scoped></style>
